import {useState, useEffect} from 'react';
import {isMobile} from "react-device-detect";
import {useLocation, useNavigate} from "react-router-dom";

import {isObject, isUndefined} from 'lodash';
import {signOut, getAuth} from "firebase/auth";

import {revertPath} from 'ultra/helpers/route';

import {getClientCity, getCityConfig} from 'ultra/configs/general';
import {isEmptyObj} from 'ultra/helpers/utils';

import Skeleton from '@mui/material/Skeleton';
import Badge from '@mui/material/Badge';
import Fab from '@mui/material/Fab';

import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

import {useIncomeStore} from '../../../../Stores/income';
import {useBackdropPreloaderStore} from '../../../../Stores/backdropPreloader';
import {useConfigStore} from '../../../../Stores/config';

import Avatar from '../../Widgets/Avatar';
import Footer from '../../Widgets/Footer';
import SelectCity from '../../Widgets/SelectCity';
import DefaultImage from '../../Widgets/DefaultImage';

import AdaptiveMenu from '../../../../Components/Adaptive/Menu';

// import {getTelegramUser} from '../../../../Helpers/telegram';
import {useGlobalCustomContext} from '../../../../Helpers/context';
import {getNodeContent} from '../../../../Helpers/content';

import {NODE_ACTIONS} from '../../Reducers/node';
import {USER_ACTIONS} from '../../../Profile/Reducers/user';

import {userLogout} from '../../../Profile/Helpers/user';

import Preloader from '../../../../Components/Preloaders/Preloader';

import UserLinksHeader from '../../Components/UserPic/UserLinksHeader';
import UserLinks from '../../Components/UserPic/UserLinks';

import './index.scss'

export default function UserPic(props) {
  const {showCity} = props;

  const {nodeDispatch, nodeState, userState, userDispatch} = useGlobalCustomContext();

  const {showBackdropPreloader, hideBackdropPreloader} = useBackdropPreloaderStore()

  const {configs} = useConfigStore();
  const {income} = useIncomeStore();

  const location = useLocation();
  const navigate = useNavigate();

  const [anchorUserMenu, setAnchorUserMenu] = useState();

  const auth = getAuth();  

  // if (userState?.userLoginInProgress) {
  //   return <div className='UserPic user'>
  //     <Skeleton variant="circular" width={30} height={30} />
  //   </div>
  // }

  const city = getClientCity(window);
  const cityConfig = getCityConfig(configs, city);

  // if use is tempty object it means user not authorised
  // !userState?.user || 
  //  && !userState?.userLoginInProgress
  // if (telegram) return <div className='userArea'>
  //   <span className='iconsSet'>
  //     <span className='AvatarWrap AvatarMinimal'>
  //       {telegram.photoURL && <img className='Avatar' src={telegram.photoURL} />}
  //     </span>
  //   </span>

  //   <SelectCity config={cityConfig} />
  // </div>

  const pathnameProfileParts = window.location.pathname.split("/")
  const profileWithNav = [
    'content',
    'library',
    'networking',
    'users',
    'messages',
    'partnership',
    'history',
  ]
  // const isOtherProfilePage = pathnameProfileParts.length === 3 && !profileWithNav.includes(pathnameProfileParts[2])
  // if (isOtherProfilePage || window.location.pathname === '/profile/login' || window.location.pathname === '/profile') {
  //   return <></>
  // }

  const onUserClickHandler = (event) => {
    setAnchorUserMenu(event.currentTarget)
    nodeDispatch({type: NODE_ACTIONS.OPEN_USER_MENU});
  }

  const onLoginHandler = () => {
      userDispatch({type: USER_ACTIONS.LOGIN});
  }

  const handleUserMenuClose = () => {
      // userDispatch({type: USER_ACTIONS.PROFILE_EDIT_CLOSE});
      nodeDispatch({type: NODE_ACTIONS.CLOSE_USER_MENU});
  }

  // TODO: make one function / has duplicate
  const onExitHandler = () => {
    handleUserMenuClose();
    showBackdropPreloader();

    userLogout()
      .promise
      .then(async () => {
          signOut(auth);

          userDispatch({type: USER_ACTIONS.USER_REMOVE});

          nodeDispatch({type: NODE_ACTIONS.CLOSE_USER_MENU});

          hideBackdropPreloader();

          const isProfilePage = location.pathname.indexOf('/profile') === 0

          if (isProfilePage) {
            navigate('/');
          }
          else {
            const city = getClientCity(window);
            
            try {
              await getNodeContent({
                city,
                uri: revertPath(location.pathname)
              }).promise

              navigate(location.pathname + location.search);
            }
            catch (e) {
              navigate('/');
            }
          }

          window.localStorage.removeItem("verify-email-msg-displayed");
      })
      .catch(() => {
        userDispatch({type: USER_ACTIONS.USER_REMOVE});
      })
  }

  if (window.location.pathname.indexOf('/profile') == 0 && !profileWithNav.includes(pathnameProfileParts[2])) {
    return <></>
  }

  if (isUndefined(userState?.user)) {
    return <div className='UserPic user'>
      <Skeleton variant="circular" width={30} height={30} />
    </div>
  }

  else {
    return <div className='UserPic user'>
      <div className={`userArea ${!userState?.user ? "loginLink" : ""}`}>
        {/* <span className='iconsSet'> */}
            {!(isObject(userState?.user) && isEmptyObj(userState?.user)) && <>
              <Badge
                color='error'
                badgeContent={income}
                onClick={onUserClickHandler}
              >
                {userState?.userUpdateInProgress && <span className='preloader'><Preloader /></span>}
                <Avatar image={userState?.user?.photoURL} roles={userState?.user?.roles} minimal="true" />
              </Badge>
              <AdaptiveMenu
                  open={nodeState.openUserMenu}
                  onClose={handleUserMenuClose}
                  anchorMenu={anchorUserMenu}
                  className="UserPicLinks"
                  title="Мій Простір"
                  links={<UserLinks closeMenu={handleUserMenuClose} onExit={onExitHandler} />}
                  header={<UserLinksHeader closeMenu={handleUserMenuClose} />}
                  footer={isMobile ? <Footer /> : <></>}
                />
              </>
            }

            {(isObject(userState?.user) && isEmptyObj(userState?.user)) && <>
              {userState?.userUpdateInProgress && <span className='preloader'><Preloader /></span>}
              {/* className='loginIcon'  */}
              <span style={{display: "flex"}} onClick={onLoginHandler}>
                <PersonOutlineOutlinedIcon className='UserIcon' />
                {/* {isMobile ? <PersonIcon /> : <AccountCircleOutlinedIcon />} */}
              </span>
            </>}

        {/* </span> */}

        {showCity && <SelectCity config={cityConfig} />}
      </div>
    </div>
  }
}
